import type { FilterProps } from './src/@types';
import { FiltersRoot } from './src/components/atoms/FiltersRoot';

import { FilterSearch } from './src/components/organisms/FilterSearch';
import { FilterAiSearch } from './src/components/organisms/FilterAiSearch';
import { FilterLocation } from './src/components/organisms/FilterLocation';
import { FilterContactStatus } from './src/components/organisms/FilterContactStatus';
import { FilterContactInfo } from './src/components/organisms/FilterContactInfo';
import { FilterBusinessInfo } from './src/components/organisms/FilterBusinessInfo';

import { useFiltersContext } from './src/providers/FilterProvider';

import { parseLocationToPlace } from './src/utils/parseCoordinatesToPlace';

export type { FilterProps };
export { parseLocationToPlace };
export { useFiltersContext };

export const Filters = {
	Root: FiltersRoot,
	Search: FilterSearch,
	AiSearch: FilterAiSearch,
	Location: FilterLocation,
	ContactStatus: FilterContactStatus,
	ContactInfo: FilterContactInfo,
	BusinessInfo: FilterBusinessInfo
};
